import { Field, Form, Formik, FormikProps } from 'formik'
import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import apiService from "../services/api"
import { useLogger } from "../framework/logger"
import { ArrowLeftCircle as BackIcon } from '../svgicons/ArrowLeftCircle'
import { now } from "../framework/utils/date"
import { useTranslation } from 'react-i18next'
import { News } from "../models/News"
import { Autocomplete, AutocompleteChangeReason, Box, Button, Theme, TextField, Typography, Badge, Checkbox } from "@mui/material"
import { newsImageDataSelector,  useTypeNews } from '../atoms/news'
import { useUser } from '../atoms'
import DatePicker from '@mui/lab/DatePicker'
import { GroupDescriptor } from '../models/GroupDescriptor'
import { useGroupDescriptors } from '../atoms/portale'
import moment from 'moment'
import { getNewsValidationSchema } from '../validation/news'
import logConstants from '../utils/logConstants'
//import EditorField from '../wjsiwyg/editorField'
import ReactQuillEditor from '../quill/reactQuillEditor'
import { useDropzone } from 'react-dropzone'
import { BrowserUtils } from '../framework/utils'
import { makeStyles, createStyles } from "@mui/styles"
import clsx from 'classnames'
import { useRecoilValue } from 'recoil'
import Confirm from '../framework/ui/feedback/confirm'
import { livelliOptions, OptionType } from '../constants/index'

const useStyles = makeStyles((theme: Theme) => createStyles({
    dropzone: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '1rem',
        borderWidth: 2,
        borderRadius: 2,
        borderColor: '#eeeeee',
        borderStyle: 'dashed',
        backgroundColor: '#fafafa',
        color: '#bdbdbd',
        outline: 'none',
        transition: 'border .24s ease-in-out',
        // marginBottom: '1rem'
    },
    dragActive: {
        borderColor: '#2196f3'
    },
    dragReject: {
        border: 'solid 2px red',
        backgroundColor: '#ffe0e0',
    },
    dragAccept: {
        border: 'solid 2px green',
        backgroundColor: '#e0ffe0',
    },
    file: {
        marginTop: 8,
        cursor: 'pointer'
    },
}))

function NewsEditPage() {
    const navigate = useNavigate();
    const user = useUser()
    const logger = useLogger({ key: 'news' });
    const { id, type } = useParams()
    const { news, setNews, resetNews, newsUpdated, fetchNews } = useTypeNews(type)
    //const avatar = useRecoilValue(newsImageDataSelector(news && news?.id !== 0 ? news.id : parseInt(id!)))
    const avatar = useRecoilValue(newsImageDataSelector(parseInt(id!)))
    const { array: groups, areaDictionary } = useGroupDescriptors()
    const { t } = useTranslation()
    const classes = useStyles()
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
    const [provinceSel, setProvinceSel] = useState<OptionType[]>([])
    const [livelliSel, setLivelliSel] = useState<OptionType[]>([])
    
    //const livelliOptionsWithBlank = [...livelliOptions, {label: 'Tutti', value: ''}]
    const handleBack = () => {
        navigate('/');
    }
    const province: OptionType[] = user?.context?.province.map<OptionType>(x => ({ label: x.descrizione, value: x.descrizione }))/*.concat({label: 'Tutte', value: ''})*/ ?? []
    
    const setSelectProvince = (formik: FormikProps<News>, selectValue: OptionType[] | null) => {
        let value: string = ''
        // console.log('province selected', selectValue)
        if (selectValue && selectValue.length > 0) {
            selectValue.forEach(item => {
                value += item.label + ','
            })
        }
        // console.log('value of foreach', value)
        formik.setFieldValue('province', value)
    }
    
    const setSelectLivelli = (formik: FormikProps<News>, selectValue: OptionType[] | null) => {
        let value: string = ''
        // console.log('province selected', selectValue)
        if (selectValue && selectValue.length > 0) {
            selectValue.forEach(item => {
                value += item.label + ','
            })
        }
        // console.log('value of foreach', value)
        formik.setFieldValue('livelli', value)
    }
        
    const getValueForAutocompleteMultiple = (myValue: string) => {
        let myValues = myValue.split(';')
            .filter(x => x !== '')
            .map<GroupDescriptor>(x => (areaDictionary[x.trim()]));
        if (myValues) return myValues
        return undefined;
    }

    interface Props {
        setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
        submitForm: () => Promise<void>
    }
    
    //Component for Upload
    const UploadComponent = ({ setFieldValue, submitForm }: Props) => {
        const { getRootProps, getInputProps, isDragReject, isDragAccept, isDragActive } = useDropzone({
            //accept: "*.png, *.jpg",
            onDrop: (files) => {
                let f = files[0];
                console.log({f})
                BrowserUtils.convertFileToBase64(f)
                    .then((data: string) => {
                        console.log({data})
                        setFieldValue('fileEncoded', data)
                        setTimeout(() => {
                            submitForm()
                        }, 100)
                    })
                    .catch((err: any) => {
                        // console.log('error', err)
                    })
            }
        });

        return (
            <Box>
                <div
                    className={clsx(classes.dropzone,
                        isDragActive && classes.dragActive,
                        isDragAccept && classes.dragAccept,
                        isDragReject && classes.dragReject)}
                    {...getRootProps()}
                >
                    <input title='Drop image here' {...getInputProps()} />
                    {isDragActive ? (
                        <p>Trascina il file qui ...</p>
                    ) : (
                        <p>Trascina e rilascia dei files qui oppure fai click per selezionare i files</p>
                    )}
                </div>
            </Box>
        );
    };

    const handleDelete = () => {
    }
    
    const displayControl = (onDelete?: () => void) => {
        let control = avatar ? (
            <Box sx={{ overflow: 'auto' }}>
                <img src={avatar} style={{ maxWidth: 240, maxHeight: 400 }} alt='Avatar' />
            </Box>
        ) : null;
        if (onDelete) {
            control = (
                <Badge
                    color="error"
                    badgeContent="X"
                    onClick={(e: React.MouseEvent) => {
                        setIsDeleteDialogOpen(true);
                        e.stopPropagation();
                    }}
                >
                    {control}
                </Badge>
            )
        }
        return <div className={classes.file}>{control}</div>;
    }
            
    useEffect(() => {
        if (news.id.toString() !== id) {
            console.log(`%cDevo rileggere l'atomo ${id}`, logConstants.magenta10ptBold)
            if (id) {
                fetchNews(parseInt(id)).then((n) => {
                    console.log(`%cRiletto ${id} %o`, logConstants.red12ptBold, n)
                })
            } else {
                resetNews()
            }
        }
        //Get the data from news and fill province
        if (id && id !== "0" && news && news.province !== null) {
            let provinces: Array<string> = news.province.split(',')
            let provincesSelected: OptionType[] = []
            provinces.forEach(x => {
                if (x) {
                    let valuePerProvince: OptionType = {label: x, value: x}
                    provincesSelected = [...provincesSelected, valuePerProvince]                    
                }
            })
            // console.log('provincesSelected', provincesSelected)
            setProvinceSel(provincesSelected)
            
            //Fill livelli
            let livellis: Array<string> = news.livelli.split(',')
            let livellisSelected: OptionType[] = []
            livellis.forEach(x => {
                if (x) {
                    let valueLivello: OptionType = {label: x, value: x}
                    livellisSelected = [...livellisSelected, valueLivello]                    
                }
            })
            setLivelliSel(livellisSelected)
        }
    }, [fetchNews, id, news, resetNews, setNews])

    return (
        <>
            <Box sx={{ display: 'flex', width: '100%', flexDirection: 'column' }} title={`News id: ${news.id}`} key={news.id}>
                <Box sx={{ display: 'flex', width: '100%', flexDirection: 'row', padding: '10px 0 0 13px' }}>
                    <Button onClick={handleBack} title={t('Indietro')}>
                        <BackIcon size={28} />
                    </Button>
                    <Typography variant="h3">{t('Gestione notizia')}</Typography>
                </Box>
                <Box sx={{ display: 'flex', width: '100%', flexDirection: 'row' }}>
                    <Formik
                        initialValues={news}
                        onSubmit={(values, { setSubmitting }) => {
                            console.log('submitting')
                            if (news?.id === 0) {
                                const insertNews: News = {
                                    id: 0,
                                    userCre: user?.name,
                                    userUpd: user?.name,
                                    dateCre: now(),
                                    dateUpd: now(),
                                    title: values.title,
                                    subtitle: values.subtitle,
                                    body: values.body,
                                    important: values.important,
                                    validUntil: values.validUntil,
                                    aree: values.aree,
                                    expired: false,
                                    notaOperativa: values.notaOperativa,
                                    newsImage: null,
                                    fileEncoded: values.fileEncoded,
                                    publish: values.publish,
                                    notify: values.notify,
                                    managed: null,
                                    livelli: values.livelli,
                                    province: values.province
                                }
                                console.log('Insert News', insertNews)
                                apiService.saveNews(insertNews).then(newsAdded => {
                                    if (newsAdded) {
                                        // console.log('values post insert', values)                            
                                        console.log('item added', newsAdded)
                                        values.id = newsAdded.id
                                        //console.log(searchParams.get('id'));
                                        //console.log(searchParams.get('type'));
                                        //setSearchParams({...searchParams, id: news.id});
                                        //console.log({news?.fileEncoded})
                                        //avatar = ImageUtils.fromBase64ToDataUrl(news?.fileEncoded, 'png')
                                        newsUpdated()
                                        navigate('/ednews/' + newsAdded?.id + '/' + type)
                                        logger.info(`News: ${news.title} aggiunto!`);
                                    } else {
                                        logger.error('Problemi nella creazione della news');
                                    }
                                }).catch(error => {
                                    console.error('Error in saving news');
                                    logger.error(error, 'error');
                                }).finally(() => {
                                    setSubmitting(false);
                                })
                            } else {
                                //console.log({dataUpload})
                                const updNews = {
                                    ...values,
                                    userUpd: user?.name,
                                    dateUpd: now(),
                                    dateCre: news?.dateCre,
                                    userCre: news?.userCre,
                                }
                                console.log('values', values)
                                console.log('news updated', updNews)
                                //console.log('datauload', dataUpload)
                                apiService.saveNews(updNews).then(news => {
                                    newsUpdated()
                                    if (news) {
                                        console.log('news updated', news)
                                        logger.info(`News : ${news.title} aggiornato!`);
                                    } else {
                                        logger.error('Problemi nel salvataggio della news ');
                                    }
                                }).catch(error => {
                                    console.error('Error in saving News ');
                                    logger.error(error, 'error');
                                }).finally(() => {
                                    setSubmitting(false);
                                    //props.onSubmit && props.onSubmit();                            
                                })
                            }
                        }}
                        //TODO
                        validationSchema={getNewsValidationSchema()}
                    >
                        {(formik: FormikProps<News>) => {
                            const { values, setFieldValue, handleChange, submitForm } = formik
                            return (
                                <Form style={{ width: '100%', padding: '10px 30px 10px 30px' }}>
                                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                                        {/*
                                        <Box sx={{ marginBottom: '20px', display: 'flex', flexDirection: 'column' }}>
                                            <label htmlFor="id"><b>{t('Id')}</b></label>
                                            <TextField id="id" name="id" value={values.id} type="text" disabled size='small' />
                                            {formik.touched.id && formik.errors.id ? (
                                                <Box>{formik.errors.id}</Box>
                                            ) :
                                            null}
                                        </Box>
                                        */}
                                        <Box sx={{ marginBottom: '20px', display: 'flex', flexDirection: 'column' }}>
                                            <label htmlFor="validUntil"><b>{t('Valido fino a')}</b></label>
                                            <DatePicker
                                                value={values.validUntil}
                                                onChange={(newValue) => {
                                                    // const temp = moment(newValue)
                                                    // console.log(`%cvalidUntil: ${newValue} ${temp.format('YYYY-MM-DD')}`, logConstants.red12ptBold)
                                                    setFieldValue('validUntil', moment(newValue).format('YYYY-MM-DD'));
                                                }}
                                                inputFormat="dd/MM/yyyy"
                                                renderInput={(params) => <TextField {...params} size='small' />}
                                            />
                                            {formik.touched.validUntil && formik.errors.validUntil ? (
                                                <Box sx={{ color: 'red' }}>{formik.errors.validUntil}</Box>
                                            )
                                                : null}
                                        </Box>
                                        <Box sx={{ marginBottom: '20px', display: 'flex', flexDirection: 'column' }}>
                                            <label htmlFor="important"><b>{t('Importante')}</b></label>
                                            <Box sx={{ pt: 1.25, alignSelf: 'center' }}>
                                                <Field
                                                    id="important"
                                                    name="important"
                                                    type="checkbox"
                                                />
                                            </Box>
                                        </Box>
                                        <Box sx={{ marginBottom: '20px', display: 'flex', flexDirection: 'column' }}>
                                            <label htmlFor="notaOperativa"><b>{t('Nota operativa')}</b></label>
                                            <Box sx={{ pt: 1.25, alignSelf: 'center' }}>
                                                <Field
                                                    id="notaOperativa"
                                                    name="notaOperativa"
                                                    type="checkbox"
                                                />
                                            </Box>
                                        </Box>
                                        <Box sx={{ marginBottom: '20px', display: 'flex', flexDirection: 'column' }}>
                                            <label htmlFor="publish"><b>{t('Pubblica')}</b></label>
                                            <Box sx={{ pt: 1.25, alignSelf: 'center' }}>
                                                <Field
                                                    id="publish"
                                                    name="publish"
                                                    type="checkbox"
                                                />
                                            </Box>
                                        </Box>
                                    </Box>
                                    <label htmlFor="aree"><b>{t('Aree competenza')}</b></label>
                                    <Box style={{ marginBottom: '20px' }}>
                                        <Autocomplete
                                            id="aree"
                                            multiple={true}
                                            filterSelectedOptions
                                            options={groups ?? []}
                                            value={getValueForAutocompleteMultiple(values.aree)}
                                            onChange={(event: React.SyntheticEvent<Element, Event>, value: GroupDescriptor[], reason: AutocompleteChangeReason) => {
                                                const result = value ? value.reduce((p, x) => `${p}${x.area};`, '') : ''
                                                // console.log('result for aree', result?.toString().replace(',', ''))
                                                setFieldValue("aree", result?.toString().replace(',', ''));
                                            }}
                                            renderInput={params => (
                                                <TextField
                                                    {...params}
                                                    name="language"
                                                    variant="outlined"
                                                    fullWidth
                                                    size='small'
                                                />
                                            )}
                                        />
                                        {formik.touched.aree && formik.errors.aree ? (
                                            <Box>{formik.errors.aree}</Box>
                                        )
                                            : null}
                                    </Box>
                                    <label htmlFor="title"><b>{t('Titolo')}</b></label>
                                    <Box style={{ marginBottom: '20px' }}>
                                        <TextField
                                            id="title"
                                            name="title"
                                            type="text"
                                            value={values.title}
                                            fullWidth
                                            onChange={handleChange}
                                            size='small'
                                        />
                                        {formik.touched.title && formik.errors.title ? (
                                            <Box sx={{ color: 'red' }}>{formik.errors.title}</Box>
                                        )
                                            : null}
                                    </Box>
                                    <label htmlFor="subtitle"><b>{t('Sotto titolo')}</b></label>
                                    <Box style={{ marginBottom: '20px' }}>
                                        <TextField
                                            id="subtitle"
                                            name="subtitle"
                                            type="text"
                                            value={values.subtitle}
                                            fullWidth
                                            onChange={handleChange}
                                            size='small'
                                        />
                                        {formik.touched.subtitle && formik.errors.subtitle ? (
                                            <Box sx={{ color: 'red' }}>{formik.errors.subtitle}</Box>
                                        )
                                        : null}
                                    </Box>
                                    <Box sx={{marginBottom: '20px', display: 'flex'}}>
                                        <Box sx={{display: 'flex', flexDirection: 'column', width: '70%'}}>
                                            <label htmlFor="body"><b>{t('Contenuto news (obbligatorio)')}</b></label>
                                            {/*  Editor react quill  */}
                                            <Box sx={{ border: 'solid 1px #d0d0d0', p: 1, borderRadius: '4px'}}>
                                                {formik.errors.body && formik.touched.body ? (
                                                    <Box sx={{ color: 'red' }}>{formik.errors.body}</Box>
                                                )
                                                : null
                                                }
                                                <ReactQuillEditor setFieldValue={setFieldValue} fieldValue={values.body} fieldName={'body'} placeholder={'Scrivere il contetnuto...'} />
                                                    {/*  Editor React Draft wjsiwyg  
                                                    <Field 
                                                        component={EditorField}
                                                        name="body"
                                                        label={t("Write a news")}
                                                        placeholder={t("content here")}
                                                        style={{minHeight: '200px'}}
                                                    />
                                                    */}
                                            </Box>
                                        </Box>
                                        <Box sx={{display: 'flex', flexDirection: 'column', width: '30%', pl: 1}}>
                                            <label htmlFor="avatar"><b>{t('Immagine della news')}</b></label>
                                            {!avatar ?
                                                <Box sx={{ border: 'solid 1px #d0d0d0', p: 1, borderRadius: '4px'}}>
                                                    <UploadComponent setFieldValue={setFieldValue} submitForm={submitForm} />
                                                </Box>                                            
                                                :
                                                displayControl(handleDelete)
                                            }
                                        </Box>
                                        <Confirm
                                            open={isDeleteDialogOpen}
                                            onCancel={() => setIsDeleteDialogOpen(false)}
                                            onConfirm={() => {
                                                setFieldValue('newsImage', null)
                                                setFieldValue('fileEncoded', null)
                                                setTimeout(() => {
                                                    submitForm()
                                                }, 100)
                                                setIsDeleteDialogOpen(false);
                                            }}
                                        />
                                    </Box>
                                    {values.notaOperativa === false &&
                                    <section style={{display: 'flex', gap: 1 , border: '1px ridge rgb(200,200,203)'}}>
                                        <Box sx={{ marginBottom: '20px', display: 'flex', flexDirection: 'column' }}>
                                            <label htmlFor="notify"><b>{t('Notifica')}</b></label>
                                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', width: '60px' }}>
                                                <Checkbox
                                                    id="notify"
                                                    name="notify"
                                                    checked={values.notify}
                                                    //type="checkbox"
                                                    //width="200px"
                                                    onChange={(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
                                                        setFieldValue('notify', checked)
                                                        if (checked === false) {
                                                            setLivelliSel([]);
                                                            setFieldValue('livelli', '')
                                                            setProvinceSel([]);
                                                            setFieldValue('province', '')
                                                        }
                                                    }}
                                                    //sx={{mb: 2}}
                                                />
                                            </Box>
                                        </Box>
                                        {values.notify &&
                                        <>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', width: '45%'}}>
                                            <label htmlFor="livello"><b>{t('Livelli (lasciare vuoto per selezionarli tutti)')}</b></label>
                                            <Autocomplete 
                                                id="livello" 
                                                options={livelliOptions} 
                                                multiple={true} 
                                                value={livelliSel}
                                                //onChange={(value: OptionType) => formik.setFieldValue('groupDescriptorId', value)} 
                                                onChange={(event: React.SyntheticEvent<Element, Event>, value: OptionType[] | null, reason: AutocompleteChangeReason) => {
                                                    //const result = value ? value.reduce((p, x) => `${p}${x.area};`, '') : ''
                                                    setLivelliSel(value ?? []);
                                                    setSelectLivelli(formik, value)
                                                }}
                                                renderInput={params => (
                                                    <TextField
                                                        {...params}
                                                        name="livelli"
                                                        variant="outlined"
                                                        fullWidth
                                                        size='small'
                                                    />
                                                )}
                                                style={{width: '100%', display: 'flex'}}
                                            />                                        
                                            {formik.touched.livelli && formik.errors.livelli ? (
                                                <Box sx={{ color: 'red' }}>{formik.errors.livelli}</Box>
                                            ) : null}
                                        </Box>
                                        <Box sx={{ display: 'flex', flexDirection: 'column', width: '45%' }}>
                                            <label htmlFor="province"><b>{t('Province (lasciare vuoto per selezionarle tutte)')}</b></label>
                                            <Box>
                                                <Autocomplete
                                                    id="province" 
                                                    multiple={true} 
                                                    filterSelectedOptions
                                                    options={province} 
                                                    value={provinceSel}
                                                    onChange={(event: React.SyntheticEvent<Element, Event>, value: OptionType[] | null, reason: AutocompleteChangeReason) => {
                                                        //const result = value ? value.reduce((p, x) => `${p}${x.value};`, '') : ''
                                                        setProvinceSel(value ?? [])
                                                        setSelectProvince(formik, value)
                                                    }}
                                                    renderInput={params => (
                                                        <TextField
                                                            {...params}
                                                            name="province"
                                                            variant="outlined"
                                                            fullWidth
                                                            size='small'
                                                        />
                                                    )}
                                                    style={{width: '100%', display: 'flex'}}
                                                />
                                            </Box>
                                        </Box> 
                                        </>                                        
                                        }                           
                                    </section>
                                    }
                                    <Box sx={{ mt: 1 }}>
                                        <Button type="submit" disabled={formik.isSubmitting} title={t('Salva')} variant="outlined">
                                            {formik.isSubmitting ? "Attendere..." : ""}
                                            Salva
                                        </Button>
                                    </Box>
                                </Form>
                            )
                        }}
                    </Formik>
                </Box>
            </Box>
        </>
    )
}

export default NewsEditPage
